<template>
    <div class="vue-image-slider">
        <hooper ref="carousel" :settings="hooperSettings">
            <slot></slot>
        </hooper>

        <ef2-slider-navigation
            @slider-next="handleSliderNext"
            @slider-previous="handleSliderPrevious"
        ></ef2-slider-navigation>
    </div>
</template>

<script>
export default {
    name: "ImageSlider",

    props: ['eventBus'],

    data() {
        return {
            hooperSettings: {
                itemsToShow: 1,
                wheelControl: false,
                infiniteScroll: true
            },
        }
    },

    methods: {
        handleSliderNext() {
            this.$refs.carousel.slideNext();
            window.blazy();
        },

        handleSliderPrevious() {
            this.$refs.carousel.slidePrev();
            window.blazy();
        }
    }
}
</script>